import cx from 'classnames'
import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import {
  platformStoreGet,
  isValidDistributorForInAppDonations,
} from '../../../../../shared/helpers'
import { useAppSelector } from '../../../hooks/useStore'
import FocusableButtonTS from '../../FocusableButton/FocusableButtonTS'
import { PlayIcon } from '../../Icons'
import { ButtonProps } from '../types'
import useCheckPassportStatus, {
  ACTIVATED_PASSPORT,
  PENDING_PASSPORT,
} from './hooks/useCheckPassportStatus'
import { ContentActionButtonFocusKeys } from './types'
import { getPlayButtonDetails } from './utils'

function Play(props: ButtonProps) {
  const [isFocused, setIsFocused] = useState(false)
  const navigate = useNavigate()

  const { user, content, station, device } = useAppSelector((state) => ({
    user: state.user,
    content: state.content,
    station: state.station,
    device: state.device,
  }))
  const { label } = getPlayButtonDetails(content.videoDetails)
  const isComcastPlatform = isValidDistributorForInAppDonations(
    device.distributor
  )
  const { passportStatus } = useCheckPassportStatus(isComcastPlatform)
  const contentIsMVOD = content.videoDetails.is_mvod
  const playbackUrl = `/video-playback/${encodeURIComponent(content.id)}`
  const passportActivationUrl = '/passport-activation'

  const isContentPlayable =
    content.videoDetails.isPlayable || user.ignoreIsPlayable
  const { isPlayableExplanation } = content.videoDetails

  const unactivatedPassport = platformStoreGet('mvault_id')

  const activatedPassport = passportStatus === ACTIVATED_PASSPORT
  const pendingPassport = passportStatus === PENDING_PASSPORT

  const shouldShowPlayButton =
    !isContentPlayable &&
    isPlayableExplanation &&
    isPlayableExplanation.length === 1 &&
    isPlayableExplanation.includes('vppa_status')

  const onPressAction = () => {
    if (!content?.videoDetails?.url) {
      navigate('/error', { replace: true })
      return
    }
    if (
      (isContentPlayable || shouldShowPlayButton) &&
      (user.validPassport || !contentIsMVOD)
    ) {
      navigate(playbackUrl, { replace: true })
    } else if (!user.validPassport && contentIsMVOD && activatedPassport) {
      navigate(playbackUrl, { replace: true })
    } else if (!user.validPassport && contentIsMVOD && pendingPassport) {
      const stationShortName = station.short_common_name
      navigate(passportActivationUrl, {
        state: { stationTitle: stationShortName },
      })
    }
    props.onPress(label)
  }

  const onFocus = () => {
    setIsFocused(true)
    props.onFocus({
      label,
    })
  }

  const onBlur = () => {
    setIsFocused(false)
  }

  if (
    !(
      isContentPlayable ||
      shouldShowPlayButton ||
      pendingPassport ||
      !!unactivatedPassport
    )
  ) {
    return <></>
  }
  return (
    <div className="video-detail-screen__control-button">
      <FocusableButtonTS
        focusKey={ContentActionButtonFocusKeys.PLAY}
        onEnterPress={onPressAction}
        onArrowPress={props.onArrowPress}
        onFocus={onFocus}
        onBlur={onBlur}
        stealFocus
      >
        <PlayIcon />
      </FocusableButtonTS>
      <span
        className={cx('video-detail-screen__control-button-label', {
          'video-detail-screen__control-button-label--focused': isFocused,
        })}
      >
        {label}
      </span>
    </div>
  )
}

export default Play
